import ContactHeaderFieldsEditButton from './ContactHeaderFieldsEditButton'
import withSidebarModalPositioning from '../withSidebarModalPositioning'

export default withSidebarModalPositioning(ContactHeaderFieldsWithMenuPosition)

function ContactHeaderFieldsWithMenuPosition({
  doRecalc,
  doSetMenu,
  email,
  firstName,
  lastName,
  menuRef,
  offset,
  openMenu,
  subjectId,
}) {
  return (
    <>
      <div className="nameAndEmail">
        <div className="name">
          {firstName}
          {firstName && lastName && ' '}
          {lastName}
        </div>
        <div className="email">{email}</div>
      </div>
      <ContactHeaderFieldsEditButton
        doRecalcMenuPosition={doRecalc}
        doSetMenu={doSetMenu}
        firstName={firstName}
        lastName={lastName}
        menuRef={menuRef}
        openMenu={openMenu}
        offset={offset}
        subjectId={subjectId}
      />
    </>
  )
}
